var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoInfomaticaColorActivo200X70(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 42,
    viewBox: "0 0 120 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2119_40791)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.84658 23.0244H1.7998V35.1782H4.84658V23.0244Z",
    fill: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2455 29.8703L9.33388 23.0244H7.00879V35.1782H10.0556V28.5112L15.9308 35.1782H18.2923V23.0244H15.2455V29.8703Z",
    fill: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.252 35.1782H23.2987V30.8874H28.5629V28.2602H23.2987V25.6877H29.3908V23.0244H20.252V35.1782Z",
    fill: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.146 22.7734C33.4503 22.7734 30.6567 25.5623 30.6567 29.1014C30.6567 32.6404 33.4503 35.4278 37.146 35.4278C40.8417 35.4278 43.6528 32.639 43.6528 29.1014C43.6528 25.5637 40.8592 22.7734 37.146 22.7734ZM37.146 32.6217C35.1629 32.6217 33.7399 31.013 33.7399 29.1014C33.7399 27.1897 35.1629 25.5796 37.146 25.5796C39.1292 25.5796 40.5522 27.1883 40.5522 29.1014C40.5522 31.0144 39.1277 32.6217 37.146 32.6217Z",
    fill: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1237 29.511L47.7616 23.0244H45.5078V35.1782H48.5546L48.5371 29.0465L51.2769 33.2478V33.2651H52.9705V33.2478L55.6914 29.0825V35.1782H58.7381V23.0244H56.4683L52.1237 29.511Z",
    fill: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.4519 22.2002L65.1708 24.0628L64.6558 25.2603L68.7487 22.9418L68.4519 22.2002Z",
    fill: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5117 35.1779H63.7564L64.5683 33.0859H69.7582L70.5876 35.1779H73.8148L68.8358 23.4541L64.4169 26.0135L60.5132 35.1794L60.5117 35.1779ZM65.5766 30.5135L67.1625 26.4738L68.7485 30.5135H65.5766Z",
    fill: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9854 25.7224H77.8978V35.1782H80.9446V25.7224H84.8382V23.0244H73.9854V25.7224Z",
    fill: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.3793 23.0244H86.3325V35.1782H89.3793V23.0244Z",
    fill: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.7238 25.5983C99.3461 25.5983 100.427 26.5462 100.771 28.064H103.889C103.51 24.9174 101.095 22.7734 97.7413 22.7734C94.047 22.7734 91.252 25.4368 91.252 29.1014C91.252 32.766 94.0456 35.4278 97.7413 35.4278C101.095 35.4278 103.509 33.2825 103.889 30.1373H100.771C100.427 31.6565 99.3461 32.6044 97.7238 32.6044C95.7232 32.6044 94.3351 31.1212 94.3351 29.1014C94.3351 27.0815 95.7232 25.5983 97.7238 25.5983Z",
    fill: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.009 22.9521H110.106L104.897 35.178H108.142L108.952 33.0861H114.143L114.973 35.178H118.2L113.009 22.9521ZM109.962 30.5122L111.548 26.4725L113.134 30.5122H109.962Z",
    fill: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.7177 16.7548C59.4631 16.7548 59.2158 16.6235 59.0805 16.3897C58.8768 16.0406 58.9975 15.5948 59.3496 15.3928L86.0183 0.0981737C86.3704 -0.103812 86.82 0.0159367 87.0237 0.365083C87.2274 0.714229 87.1067 1.16004 86.7545 1.36203L60.0844 16.6567C59.9695 16.723 59.8414 16.7548 59.7177 16.7548Z",
    fill: "url(#paint0_linear_2119_40791)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6367 16.7318C47.3821 16.7318 47.1347 16.6005 46.9994 16.3668C46.7957 16.0176 46.9165 15.5718 47.2686 15.3698L67.2646 3.89993C67.6168 3.69795 68.0663 3.81769 68.27 4.16684C68.4737 4.51599 68.353 4.9618 68.0009 5.16378L48.0048 16.6337C47.8884 16.7 47.7618 16.7318 47.6367 16.7318Z",
    fill: "url(#paint1_linear_2119_40791)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5298 16.7322C35.278 16.7322 35.0336 16.6023 34.8983 16.3715C34.6975 16.0267 34.8168 15.5852 35.1645 15.3861L48.6058 7.69043C48.955 7.49133 49.3988 7.60964 49.5996 7.95445C49.8004 8.29927 49.6811 8.74075 49.3333 8.93985L35.892 16.6355C35.7771 16.7004 35.652 16.7322 35.5283 16.7322H35.5298Z",
    fill: "url(#paint2_linear_2119_40791)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2119_40791",
    x1: 58.9815,
    y1: 8.37669,
    x2: 87.1227,
    y2: 8.37669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42C67E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A6EDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2119_40791",
    x1: 46.9005,
    y1: 10.2668,
    x2: 68.369,
    y2: 10.2668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42C67E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#3FBC86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#39A69E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#2F82C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A6EDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2119_40791",
    x1: 34.8008,
    y1: 12.163,
    x2: 49.6971,
    y2: 12.163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42C67E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A6EDB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2119_40791"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 42,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoInfomaticaColorActivo200X70);
export default __webpack_public_path__ + "static/media/LOGO_INFOMATICA_COLOR_ACTIVO_200X70.d7e7526797a9474e9f222062844bdd14.svg";
export { ForwardRef as ReactComponent };